<template>
  <div class="row">
    <div class="col-md-12">
      <h3 class="title">{{ $t('users') }}</h3>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i> {{ $t('new_user') }}
        </p-button>
      </div>
      <div class="card-body row">
        <div class="col-md-6">
          <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              :placeholder="$t('search')"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12">
          <el-table v-loading="loading" :element-loading-text="$t('loading_data') + '...'" class="table-striped" :data="paginated" border style="width: 100%">
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" sortable></el-table-column>
            <el-table-column fixed="right" width="90" class-name="td-actions text-center" :label="$t('credit')">
              <template slot-scope="props">
                  <p-button type="default" size="sm" icon @click="handlePackageModal(props.$index, props.row)">
                    <i class="fa fa-credit-card"></i>
                  </p-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right"  width="150" class-name="td-actions text-center" :label="$t('actions')">
              <template slot-scope="props">
                <p-button v-if="props.row.isVerified" title="User is already verified" type="success" size="sm" icon @click="toggleVerificationModal(props.$index, props.row)">
                  <i class="fa fa-check"></i>
                </p-button>
                <p-button v-else title="Verify user" type="warning" size="sm" icon @click="toggleVerificationModal(props.$index, props.row)">
                  <i class="fa fa-user-times"></i>
                </p-button>

                <p-button type="primary" size="sm" icon @click="handleEditModal(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>

      <div class="card-footer">
        <paginate :pagination="pagination" :metadata="metaData" :allData="getUsers"></paginate>
      </div>

    </div>

    <!-- Create and Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ (!updateState) ? $t('new_user') : $t('edit_user')}}</h4>
      <ValidationObserver ref="userForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.name" :placeholder="$t('name')" :label="$t('name')"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="surname" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.surname" :placeholder="$t('surname')" :label="$t('surname')"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="email" rules="required|email|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.email" :placeholder="$t('email')" :label="$t('email')"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="community" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.community" :placeholder="$t('community')" :label="$t('community')"></fg-input>
          </ValidationProvider>

          <fg-input :label="$t('select_user_role')">
            <el-select size="large" class="select-primary" filterable clearable v-model="form.roleID" :placeholder="$t('select_user_role')">
              <el-option
                class="select-primary"
                v-for="role in roles"
                :key="role.id"
                :label="role.display_name"
                :value="role.id"
              ></el-option>
            </el-select>
          </fg-input>

          <fg-input :label="$t('select_language')">
            <el-select size="large" class="select-primary" filterable clearable v-model="form.language_ID" :placeholder="$t('select_language')">
              <el-option
                class="select-primary"
                v-for="lang in Languages"
                :key="lang.id"
                :label="lang.name"
                :value="lang.id"
              ></el-option>
            </el-select>
          </fg-input>

          <fg-input :label="$t('select_user_ngo')">
              <el-select size="large" class="select-primary" v-model="form.ngo_ID" filterable clearable :placeholder="$t('select_user_ngo')">
                   <el-option
                   class="select-primary"
                   v-for="ngo in NGO"
                   :key="ngo.id"
                   :label="ngo.name"
                   :value="ngo.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input :label="$t('select_user_country')">
              <el-select size="large" class="select-primary" v-model="form.location_ID" filterable clearable :placeholder="$t('select_user_country')">
                   <el-option
                   class="select-primary"
                   v-for="country in Countries"
                   :key="country.id"
                   :label="country.name"
                   :value="country.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input :label="$t('select_ngo_permissions')">
              <el-select size="large" class="select-primary" v-model="form.ngos_PermissionsIDs" filterable clearable multiple="multiple" :placeholder="$t('select_ngo_permissions')">
                   <el-button @click="checkAllNGO" style="width:100%; border:none">{{ $t('select_all') }}</el-button>
                   <el-option
                   class="select-primary"
                   v-for="ngo in NGO"
                   :key="ngo.id"
                   :label="ngo.name"
                   :value="ngo.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input :label="$t('select_location_permissions')">
              <el-select size="large" class="select-primary" v-model="form.locations_PermissionsIDs" filterable clearable multiple="multiple" :placeholder="$t('select_location_permissions')">
                  <el-button @click="checkAllLocation" style="width:100%; border:none">{{ $t('select_all') }}</el-button>
                  <el-option
                   class="select-primary"
                   v-for="country in Countries"
                   :key="country.id"
                   :label="country.name"
                   :value="country.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input :label="$t('select_content_types_permission')">
              <el-select size="large" class="select-primary" v-model="form.contentTypes_PermissionsIDs" filterable clearable multiple="multiple" :placeholder="$t('select_content_types_permission')">
                   <el-button @click="checkAllContent" style="width:100%; border:none">{{ $t('select_all') }}</el-button>
                   <el-option
                      class="select-primary"
                      v-for="cont in Contents"
                      :key="cont.id"
                      :label="cont.name"
                      :value="cont.id"></el-option>
              </el-select>
          </fg-input>

        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side" v-loading="saveLoading" :element-loading-text="$t('saving_data')+'...'" >
          <p-button v-if="!updateState" type="primary" link @click="createUser">{{ (!updateState) ? $t('save') : $t('update') }}</p-button>
          <p-button v-if="updateState" type="primary" link @click="updateUser">{{ (!updateState) ? $t('save') : $t('update') }}</p-button>
        </div>
      </template>
    </modal>

    <!--  assign package modal  -->
    <modal :show.sync="modals.package" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('assign_package') }}</h4>
      <h6>{{ $t('credit_remaining') }} : {{ creditRemaining }}</h6>
      <ValidationObserver ref="userForm">
        <form>

          <fg-input :label="$t('select_package')">
            <el-select size="large" class="select-primary" filterable clearable v-model="userPackage.package_id" :placeholder="$t('select_package')">
              <el-option
                class="select-primary"
                v-for="pack in packages"
                :key="pack.id"
                :label="`${pack.name} - ${pack.quantity} ${pack.quantity >= 1 ? 'quantities' : 'quantity'}`"
                :value="pack.id"
              ></el-option>
            </el-select>
          </fg-input>


        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handlePackageCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side" v-loading="saveLoading" :element-loading-text="$t('saving_data')+'...'" >
          <p-button type="primary" link @click="updateUserPackage">{{ $t('save') }}</p-button>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Modal from "src/components/UIComponents/Modal.vue";
import Con from "@/util/helpers.js";

import Resource from "@/util/Api/resource.js";
import Paginate from '../../../UIComponents/Paginate.vue';
const UserResource = new Resource("user");
const UpdateUserResource = new Resource("user/update");
const RoleResource = new Resource("role");
const CategoryResource = new Resource("category");
const UserDeleteResource = new Resource("user/delete");
const PackageResource = new Resource("packages");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Modal,
    Paginate
  },
   data() {
    return {
      modals: {
        classic: false,
        package: false
      },
      loading: false,
      saveLoading:false,
      updateState: false,
      pagination:{
          perPage: 10,
          perPageOptions: [10, 20, 30, 60, 500, 1000],
          currentPage:1,
          nextPage:'',
          prevPage:'',
          total:'',
          from:'',
          to:'',
          page:'',
      },
      searchQuery: "",
      tableColumns: [
        {
          prop: "name",
          label: this.$t("name"),
        },
        {
          prop: "surname",
          label: this.$t("surname"),
        },
        {
          prop: "country",
          label: this.$t("country"),
        },
        {
          prop: "email",
          label: this.$t("email")
        },
        {
          prop: "community",
          label: this.$t("community")
        },
        {
          prop: "role.name",
          label: this.$t("role"),
        },
      ],
      tableData: [],
      categoriesID:[],
      NGO:[],
      Countries:[],
      Contents:[],
      roles: [],
      users:[],
      Languages:[],
      packages: [],
      metaData: {
        meta:'',
        links:''
      },
      form: {
        userID: "",
        name: "",
        surname: "",
        email: "",
        community:"",
        roleID: 1,
        ngo_ID: "",
        location_ID: "",
        language_ID: "",
        ngos_PermissionsIDs: [],
        locations_PermissionsIDs: [],
        contentTypes_PermissionsIDs: []
      },
      auth_user_id: localStorage.getItem("id"),
      userPackage: {
        user_id: '',
        package_id: ''
      },
      creditRemaining: 0
    };
  },

  methods: {

    handlePackageModal(index, row) {
      this.creditRemaining = row.credits ? row.credits.remaining : 0;
      this.resetUserPackage();

      this.userPackage.user_id = row.id;

      this.modals.package = true;
    },

    handleEditModal(index, row) {
      this.resetForm();
      this.updateState = true;
      this.form.userID = row.id;
      this.form.name = row.name;
      this.form.surname = row.surname;
      this.form.email = row.email;
      this.form.community = row.community;
      if(row.role) {
         this.form.roleID = row.role.id;
      }
      if(row.category){
         this.form.ngo_ID = row.category.ngo_ID;
         this.form.language_ID = row.category.language_ID;
         this.form.location_ID = row.category.location_ID;
      }
      if(row.permissions) {
         this.form.ngos_PermissionsIDs = Con.convertArray(row.permissions.category_Organisations);
         this.form.locations_PermissionsIDs = Con.convertArray(row.permissions.category_Locations);
         this.form.contentTypes_PermissionsIDs =  Con.convertArray(row.permissions.category_ContentTypes);
      }
      this.modals.classic = true;
    },

    resetForm() {
      this.form.name = "";
      this.form.surname = "";
      this.form.email = "";
      this.form.roleID = "";
      this.form.ngo_ID = "";
      this.form.location_ID = "";
      this.form.language_ID = "";
      this.form.community = "";
      this.form.categoriesID = [];
      this.form.ngos_PermissionsIDs = [];
      this.form.locations_PermissionsIDs = [];
      this.form.contentTypes_PermissionsIDs = [];
    },

    resetUserPackage() {
      this.userPackage.user_id = '';
      this.userPackage.package_id = '';
    },

    handleCreateModal() {
      this.resetForm();
      this.updateState = false;
      this.modals.classic = true;
    },

    handleCloseModal() {
      this.modals.classic = false;
      this.getUsers();
      this.updateState = false;
    },

    handlePackageCloseModal(){
      this.modals.package = false;``
    },

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    // Delete user
    handleDelete(index, row) {
      this.$confirm(
        this.$t("confirm_delete") + " " + this.$t('user'),
        this.$t("warning"),
        {
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "btn-danger",
          confirmButtonClass: "btn-primary",
          type: "warning"
        }
      ).then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            UserDeleteResource.deleteWithGet(this.form.id)
              .then(response => {
                 this.tableData.splice(indexToDelete, 1);
                 this.getUsers();
                 this.showAlertMessage(this.$t("deleted_successfully"), "success");
              }).catch(error => {
                 this.showAlertMessage(error.response.data.message, "error");
              });
          }
        }).catch(() => {});
    },

    toggleVerificationModal(index, row) {
      let message = row.isVerified ? this.$t("confirm_deactivation") : this.$t('confirm_activation');
      this.$confirm(
         message + " " + this.$t('user'),
        this.$t("warning"),
        {
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "btn-danger",
          confirmButtonClass: "btn-primary",
          type: "warning"
        }
      ).then(() => {
        let indexToToggle = this.tableData.findIndex(
          tableRow => tableRow.id === row.id
        );
        if (indexToToggle >= 0) {
          this.form = row;
          new Resource('user/verify').store({email: row.email})
            .then(_ => {
              this.tableData.splice(indexToToggle, 1);
              this.getUsers();
              this.showAlertMessage(row.isVerified ? this.$t("deactivation_successful") : this.$t('activation_successful'), "success");
            }).catch(error => {
              this.showAlertMessage(error.response.data.message, "error");
            });
        }
      }).catch(() => {});
    },

    getPackages() {
      PackageResource.list({})
        .then(res => {
          this.packages = res.data;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    // Get all NGOs in a categories
    async getCategories() {
      await CategoryResource.list({})
      .then(response => {
        let categories = response.data;
        categories.forEach(element => {
          if(element.name.toLowerCase().includes("ngos")) {
             this.NGO = element.children;
          } else if(element.name.toLowerCase().includes("countries")) {
             this.Countries = element.children;
          } else if (element.name.toLowerCase().includes("languages")) {
             this.Languages = element.children;
          } else if(element.name.toLowerCase().includes("content")) {
             this.Contents = element.children;
          }
        });
      }).catch(error => {
        console.log('error', error)
      });
    },

    // Get all roles
    async getRoles() {
      await RoleResource.list({})
        .then(response => {
          this.roles = response.data;
        }).catch(error => {
           console.log('error', error);
        });
    },

    // Get all users
    async getUsers(page_url) {
      this.loading = true;
      if(page_url) {
        page_url = Con.splitStringLinks(page_url);
      }
      await UserResource.list(page_url)
      .then(response => {
          this.loading = false;
          if(this.tableData.length > 0){
            this.tableData = [...response.data.data, ...this.tableData];
          } else {
            this.tableData = response.data.data;
          }
          this.metaData.meta = response.data.meta;
          this.metaData.links = response.data.links;
        }).catch(error => {
          console.log('error', error);
          this.loading = false;
        });
    },

    // Create new user
    async createUser() {
      this.saveLoading = true;

      // converting integer array to string array
      let ngo = this.form.ngos_PermissionsIDs.toString();
      let location = this.form.locations_PermissionsIDs.toString();
      let content = this.form.contentTypes_PermissionsIDs.toString();

      // re-assigning the converted values
      this.form.ngos_PermissionsIDs = ngo;
      this.form.locations_PermissionsIDs = location;
      this.form.contentTypes_PermissionsIDs = content;

      await UserResource.store(this.form)
        .then(response => {
          this.tableData = [response.data.data, ...this.tableData];
          this.handleCloseModal();
          this.resetForm();
          this.saveLoading = false;
          this.showAlertMessage(this.$t('user_created_successfully'), "success");
        }).catch(error => {
          this.saveLoading = false;
          console.log('error', error);
          if (error.response.data.errors) {
            this.$refs.userForm.setErrors(
              error.response.data.errors
            );
          }
        });
    },

    // update user
    async updateUser() {

      // converting integer array to string array
      let ngo = this.form.ngos_PermissionsIDs.toString();
      let location = this.form.locations_PermissionsIDs.toString();
      let content = this.form.contentTypes_PermissionsIDs.toString();

      // re-assigning the converted values
      this.form.ngos_PermissionsIDs = ngo;
      this.form.locations_PermissionsIDs = location;
      this.form.contentTypes_PermissionsIDs = content;

      await UpdateUserResource.updateUser(this.form)
        .then(response => {
          const user = this.tableData.findIndex(item => item.id === response.data.id);
          this.tableData.splice(user, 1, response.data.data)
          this.handleCloseModal();
          this.showAlertMessage(this.$t("user_updated_successfully"), "success");
        }).catch(error => {
          this.showAlertMessage(error.response.data.message, "error");
          if (error.response.data.errors) {
            this.$refs.userForm.setErrors(
              error.response.data.errors
            );
          }
        });
    },

    updateUserPackage() {
       this.saveLoading = true;
       new Resource('user_packages').store(this.userPackage)
        .then(res => {
          this.creditRemaining = res.data.credit;
          this.saveLoading = false;
          this.showAlertMessage(this.$t("package_assigned_successfully"), "success");
        }).catch(error => {
          this.saveLoading = false;
          this.showAlertMessage(error.response.data.message, "error");
        });
    },

    async checkAll(id){
      this.categories.forEach((element) => {
        if(element.id === 1 && id === 1){
          element.children.forEach((value) => {
              if (this.form.ngos_PermissionsIDs.some(e => e == value.id)) return;
              this.form.ngos_PermissionsIDs.push(value.id);
              if (this.categoriesID.some(e => e == value.id)) return;
              this.categoriesID.push(value.id);
          });
        } else if(element.id === 2 && id === 2){
          element.children.forEach((value) => {
              if (this.form.locations_PermissionsIDs.some(e => e == value.id)) return;
              this.form.locations_PermissionsIDs.push(value.id);
              if (this.categoriesID.some(e => e == value.id)) return;
              this.categoriesID.push(value.id);
          });
        } else if(element.id === 3 && id === 3) {
          element.children.forEach((value) => {
              if (this.form.contentTypes_PermissionsIDs.some(e => e == value.id)) return;
              this.form.contentTypes_PermissionsIDs.push(value.id);
              if (this.categoriesID.some(e => e == value.id)) return;
              this.categoriesID.push(value.id);
          });
        }

      });
    },

    async checkAllContent() {
       if(this.form.contentTypes_PermissionsIDs.length === 0) {
          this.Contents.forEach(element => {
             this.form.contentTypes_PermissionsIDs.push(element.id);
          });
       } else {
         this.form.contentTypes_PermissionsIDs = [];
       }
    },

    async checkAllLocation() {
       if(this.form.locations_PermissionsIDs.length === 0) {
          this.Countries.forEach(element => {
             this.form.locations_PermissionsIDs.push(element.id);
          });
       } else {
         this.form.locations_PermissionsIDs = [];
       }
    },

    async checkAllNGO() {
       if(this.form.ngos_PermissionsIDs.length === 0) {
          this.NGO.forEach(element => {
             this.form.ngos_PermissionsIDs.push(element.id);
          });
       } else {
         this.form.ngos_PermissionsIDs = [];
       }
    },

  },

  computed: {

    queriedUserData() {
        return Con.filterData(this.tableData, this.searchQuery);
    },

    paginated(){
        return Con.paginateData(this.queriedUserData, this.pagination);
    },

  },

  mounted(){
     this.getUsers();
  },

  created() {
     this.getCategories();
     this.getRoles();
     this.getPackages();
  },

  beforeMount() {
    let user = JSON.parse(localStorage.getItem("user"));
    if(user[0].roleName.toLowerCase() === "farmer" || user[0].roleName.toLowerCase() === "trainer") {
       this.$router.push({name: 'Overview'});
    }
  },
};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
</style>
